module.exports = __webpack_public_path__ + "files/aa852981141e886a49904dea6e5d92ee.png";